import type { DemandeDTO, ModelDemande } from '@/features/api/extranet/dto/Demande/shared'
import type { ModelDemandeLov } from '@/features/api/extranet/dto/Demande/shared/ModelDemandeLov.ts'
import type { LovDTO } from '@/features/api/extranet/dto/Lov'
import type { ErreurSummaryConfiguration } from '@/features/application/erreur-summary'
import type { DemandeActions, DemandeStore, UseDemandeStore } from '@/features/interface/demande/shared'
import type { Component, InjectionKey, Ref } from 'vue'

export type SetupDemande<TModelDemande extends ModelDemande, TTabs extends string = any> = {
  useStore: UseDemandeStore<TModelDemande>
  injectActions: () => DemandeActions
  tabFirst: TTabs
  tabsVue: Record<TTabs, Component>
  tabsErrorConfig: (demande: DemandeDTO<TModelDemande>) => ErreurSummaryConfiguration<DemandeDTO<TModelDemande>>
  getNatureFichiers?: () => LovDTO<string>
  onInititalize?: (actions: DemandeActions) => void | (() => void)
}

export type DemandeContentStore = {
  getStore<TModelDemande extends ModelDemande>(
    modelDemande: TModelDemande,
  ): DemandeStore<TModelDemande, ModelDemandeLov<TModelDemande>>
  currentStep: Ref<string>
}

export const DEMANDE_STORE: InjectionKey<DemandeContentStore> = Symbol('demande-store')
